var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDancing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#FFD881;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,183.34c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,149.04,62.94,183.34,105.63,183.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 72.46,
    cy: 111.43,
    r: 12.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.71,113.95c-2.32,0-4.19-1.88-4.19-4.19v-47.1c0-2.32,1.88-4.19,4.19-4.19s4.19,1.88,4.19,4.19 c0,5.64,2.34,7.61,5.57,10.33c6.65,5.61,11.6,11.78,4.76,30.63c-0.79,2.18-3.2,3.3-5.37,2.51c-2.18-0.79-3.3-3.19-2.51-5.37 c5.39-14.88,2.17-17.6-2.29-21.36c-0.05-0.04-0.11-0.09-0.16-0.13v30.49C84.91,112.07,83.03,113.95,80.71,113.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 98.7,
    cy: 143.03,
    r: 13.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 132.32,
    cy: 134.47,
    r: 13.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.63,147.22c-2.32,0-4.19-1.88-4.19-4.19V88.54c0-1.91,1.29-3.57,3.13-4.06l33.55-8.78 c1.26-0.33,2.6-0.06,3.62,0.74c1.03,0.79,1.63,2.02,1.63,3.32v56.96c0,2.32-1.88,4.19-4.19,4.19c-2.32,0-4.19-1.88-4.19-4.19 V85.19l-25.16,6.59v51.25C112.82,145.34,110.95,147.22,108.63,147.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.63,111.55c-1.86,0-3.56-1.25-4.05-3.13c-0.59-2.24,0.75-4.53,2.99-5.12l33.55-8.78 c2.24-0.58,4.53,0.75,5.12,2.99c0.59,2.24-0.75,4.53-2.99,5.12l-33.55,8.78C109.34,111.51,108.98,111.55,108.63,111.55z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.97,92.3c0,0.03-0.02,0.06-0.06,0.06l0,0H99.8c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06h0.11 C99.94,92.24,99.97,92.26,99.97,92.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDancing);
export default __webpack_public_path__ + "static/media/Dancing.b5db901bc649fe50e6a5b142561da7f7.svg";
export { ForwardRef as ReactComponent };